import { BoundsMatrix } from "../bounds";

/** Default bounds for Utrecht */
export const boundsUtrecht: BoundsMatrix = [
  4.93038, 51.986783, 5.25482, 52.166141,
];

/** Default bounds for Netherlands */
export const boundsNL: BoundsMatrix = [3, 50, 7.4, 54];
